import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../common/js/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class dspReport_template extends vnTemplate{

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    protected viewModeFilter: filterDropdown_template;
    protected brandsFilter: multipleSelector_template;
    protected dspFilter: multipleSelector_template;
    protected sspFilter: multipleSelector_template;
    protected datesFilter: filterDate_template;

    protected getTemplateName(): string{

        return "dspReport_template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

        return ["w-content"];
    }

    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('dspReport');

        this.viewModeFilter = new filterDropdown_template("viewModeFilter", this.getTemplateViewModel(), this.caller);
        this.viewModeFilter.setOptions([
            {id: 'date', name: 'Date View'},
            {id: 'ssp', name: 'SSP View'}
        ]);
        this.viewModeFilter.setLabel('View Mode');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("Brands");
        this.brandsFilter.setLogoEnabled(true);
        
        this.dspFilter = new multipleSelector_template("dspFilter", this.getTemplateViewModel(), this.caller);
        this.dspFilter.setTagContainerId('selected-dsp');
        this.dspFilter.setTagContainerCaption('Selected DSP:');
        this.dspFilter.setLabel("DSP");
        this.dspFilter.setSelectAllEnabled(false);
        
        this.sspFilter = new multipleSelector_template("sspFilter", this.getTemplateViewModel(), this.caller);
        this.sspFilter.setTagContainerId('selected-ssp');
        this.sspFilter.setTagContainerCaption('Selected SSP:');
        this.sspFilter.setLabel("SSP");
        this.sspFilter.setSelectAllEnabled(false);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0, 0, 0, 0);
        let firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

        if(date.getTime() === firstOfMonth.getTime()){

            firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{

            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);
    }

    protected getTemplateHtml(): string{

        return /*html*/`
            <div class="sub-header w-justify">

                ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                    ${this.viewModeFilter.getHtmlBuild()}
                    ${this.brandsFilter.getHtmlBuild()}
                    ${this.dspFilter.getHtmlBuild()}
                    ${this.sspFilter.getHtmlBuild()}
                    ${this.datesFilter.getHtmlBuild()}
                </div>
            </div>

            ${this.validationsList.getHtmlBuild()}

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-dsp"></div>
                    <div id="selected-ssp"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                    <h3 class="section-title icon i-payment">DSP Report</h3>
                </div>
            </div>
            
            <div id="list-results" style="position: relative">
                <div class="w-sticky-col">
                    <table class="list-results list-sections">
                        <thead>
                            <tr>
                                <th data-bind="attr: { colspan: dspHeaders().length + 1 }">
                                    <span>DSP</span>
                                </th>
                                <th colspan="3" class="colgroup-4 start end">
                                    <span>Revenue & Impressions</span>
                                </th>                                
                                <th colspan="4" class="colgroup-2 start end">
                                    <span>Bidding</span>
                                </th>
                            </tr>
                            <tr class="list-header-section">
                                <th class="stick-col"></th>
                                <!-- ko foreach: dspHeaders -->
                                    <th>
                                        <span data-bind="text: name"></span>
                                    </th>
                                <!-- /ko -->
                                <th class="section-portfolio-total border-left">Total Revenue</th>
                                <th class="border-left">Impressions</th>
                                <th>RPM</th>
                                <th class="border-left">Bid Requests</th>
                                <th>Bids</th>
                                <th>Bid Rate</th>
                                <th>Win Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- ko foreach: dspData -->
                            <tr data-bind="css: { total: rowLabel === 'TOTAL' }">
                                <td class="stick-col">
                                    <span data-bind="text: rowLabel"></span>
                                </td>
                                <!-- ko foreach: dspRevenue -->
                                <td>
                                    <span data-bind="text: $parents[1].formatNumber($data)"></span>
                                </td>
                                <!-- /ko -->
                                <td class="section-portfolio-total border-left">
                                    <span data-bind="text: $parent.formatNumber(totalRevenue)"></span>
                                </td>
                                <td class="border-left">
                                    <span data-bind="text: $parent.formatInteger(totalImpressions)"></span>
                                </td>
                                <td>
                                    <span data-bind="text: $parent.formatNumber(rpm)"></span>
                                </td>
                                <td class="border-left">
                                    <span data-bind="text: $parent.formatInteger(totalBidRequests)"></span>
                                </td>
                                <td >
                                    <span data-bind="text: $parent.formatInteger(totalBids)"></span>
                                </td>
                                <td >
                                    <span data-bind="text: $parent.formatPercent(bidRate)"></span>
                                </td>
                                <td>
                                    <span data-bind="text: $parent.formatPercent(winRate)"></span>
                                </td>
                            </tr>
                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    }

    protected buildViewModel(): any{

        let self = this;

        return {
            dspHeaders: ko.observableArray([]),
            dspData: ko.observableArray([]),
            formatNumber: function(value){

                return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            },
            formatInteger: function(value){

                return Number(value).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
            },
            formatPercent: function(value){

                return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
            },
        };
    }

    public getViewModelForRequest(){
        let self = this;
        return {
            dateStart: this.getTemplateViewModel().datesFilter.startDate(),
            dateEnd: this.getTemplateViewModel().datesFilter.endDate(),
            selectedBrands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            selectedDsp: this.getTemplateViewModel().dspFilter.selectedItems(),
            selectedSsp: this.getTemplateViewModel().sspFilter.selectedItems(),
            viewMode: this.viewModeFilter.getTemplateViewModel().selectedOption()
        };
    }

    public build(classesToAdd: Array<string> = []): HTMLElement{

        let container = super.build(classesToAdd);
        return container;
    }

    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
    }

    public setBrandFilterItems(portfolios){

        let groups = [];
        for(let portfolio of portfolios){

            let group = {"name": portfolio.name, "logo": portfolio.logo, "items": portfolio.brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setDspFilterItems(items){

        this.dspFilter.setItems(items);
    }

    public setSspFilterItems(items){

        this.sspFilter.setItems(items);
    }

    public setDspHeaders(headers){
        this.getTemplateViewModel().dspHeaders(headers);
    }

    public setDspData(data){
        this.getTemplateViewModel().dspData(data);
    }

    public setViewModelFromRequest(params: Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['selectedBrands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.dspFilter, params['selectedDsp']);
        this.presetFilter.setMultiSelectorPresetFilters(this.sspFilter, params['selectedSsp']);
        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['dateStart'], params['dateEnd'], params['startDateRange'], params['endDateRange']);

        if (typeof params['viewMode'] !== 'undefined'){

            this.viewModeFilter.getTemplateViewModel().selectedOption(params['viewMode']);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/dspReport_template.ts